import * as clack from '@clack/prompts'
export function normalizeShadcnPresetOnly(value: string | undefined): string | undefined {
  if (!value) {
    return undefined
  }

  const parts = value
    .split(',')
    .map((part) => part.trim().toLowerCase())
    .filter(Boolean)

  if (parts.length !== 1 || parts[0] !== 'theme') {
    clack.cancel(
      'Admin-only shadcn preset updates currently support --only theme. Omit --only to apply the full preset.'
    )
    process.exit(1)
  }

  return 'theme'
}
